import * as React from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepLabel from "@mui/material/StepLabel";
import { styled } from "@mui/material/styles";
import StepConnector, {
  stepConnectorClasses,
} from "@mui/material/StepConnector";
import { StepIconProps } from "@mui/material/StepIcon";
import { FORM_STEPS } from "../../types"; // Adjust import path as needed

const steps = ["", "", "", "", ""];

// Custom styled connector with orange color for completed steps
const OrangeConnector = styled(StepConnector)(({ theme }) => ({
  [`&.${stepConnectorClasses.alternativeLabel}`]: {
    top: 22,
  },
  [`&.${stepConnectorClasses.active}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderBottomColor: "#ff6235", // Orange color for active
    },
  },
  [`&.${stepConnectorClasses.completed}`]: {
    [`& .${stepConnectorClasses.line}`]: {
      borderBottomColor: "#ff6235", // Orange color for completed
    },
  },
  [`& .${stepConnectorClasses.line}`]: {
    height: 3,
    border: 0,
    backgroundColor: "transparent",
    borderBottom: `0px dotted ${
      theme.palette.mode === "dark" ? theme.palette.grey[800] : "#eaeaf0"
    }`,
    borderRadius: 0,
  },
}));

// Custom step icon component
const OrangeStepIcon: React.FC<StepIconProps> = (props) => {
  const { active, completed, className, icon } = props;
  const isLastStep = icon === 5;

  return (
    <Box
      className={className}
      sx={{
        width: isLastStep ? 60 : 40, // Wider for last step
        height: 40,
        border: "1px solid #e0e0e0",
        borderRadius: isLastStep ? "10px" : "50%", // Rounded rectangle for last step, circle for others
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: completed
          ? "#ff6235" // Orange for completed
          : active
          ? "#ff6235" // Orange for active
          : "#fff", // White for inactive
        color: completed || active ? "#fff" : "#e0e0e0", // White text for active/completed, gray for inactive
        fontWeight: "bold",
        fontSize: isLastStep ? "14px" : "16px", // Slightly smaller font for "Result"
        padding: isLastStep ? "0 8px" : 0, // Add padding for the last step
      }}
    >
      {/* Show "Result" for the last step, numbers for others */}
      {isLastStep ? "Result" : icon}
    </Box>
  );
};

interface YoutubeStepperProps {
  currentStep: number;
}

const YoutubeStepper: React.FC<YoutubeStepperProps> = ({ currentStep }) => {
  // Map form steps to stepper indices (first 5 steps only)
  const getActiveStep = (step: number): number => {
    switch (step) {
      case FORM_STEPS.INJURY:
        return 0;
      case FORM_STEPS.REPRESENTATION:
        return 1;
      case FORM_STEPS.FAULT:
        return 2;
      case FORM_STEPS.DETAILS:
        return 3;
      case FORM_STEPS.WHEN:
        return 4;
      default:
        // For steps beyond the first 5, show as completed (step 4)
        return 4;
    }
  };

  const activeStep = getActiveStep(currentStep);

  return (
    <Box
      sx={{
        mt: "1rem",
        width: "100%",
        display: "flex",
        justifyContent: "center",
        px: 0, // Add horizontal padding for mobile
      }}
    >
      <Box
        sx={{
          width: "100%",
          maxWidth: {
            xs: "350px", // Mobile: very compact
            sm: "350px", // Small tablets: slightly wider
            md: "350px", // Medium screens
            lg: "370px", // Large screens
          },
        }}
      >
        <Stepper activeStep={activeStep} connector={<OrangeConnector />}>
          {steps.map((label, index) => {
            const stepProps: { completed?: boolean } = {};
            const labelProps: {
              optional?: React.ReactNode;
              StepIconComponent?: typeof OrangeStepIcon;
            } = {};

            // Mark steps as completed if we've moved past them
            if (index < activeStep) {
              stepProps.completed = true;
            }

            // Use custom step icon
            labelProps.StepIconComponent = OrangeStepIcon;

            return (
              <Step key={label} {...stepProps}>
                <StepLabel {...labelProps}>{label}</StepLabel>
              </Step>
            );
          })}
        </Stepper>
      </Box>
    </Box>
  );
};

export default YoutubeStepper;
